import React, { useState } from 'react';
import works from '../works';
import Nav from './Nav';
import {Link } from "react-router-dom";
import Fade from 'react-reveal/Fade';

import Zoom from 'react-reveal/Zoom';

class Work extends React.Component {
 




  render(){ 
      let id = this.props.match.params.id
      let work = works.find(x => x.slug === id);
      let next = works.findIndex(x => x.slug === id) + 1;
      let nextWork 
      if(works[next]){
          nextWork = works[next]
      }else{
          nextWork = works[0]
      }
      // going to a new project the page needs to scrool up and since the url doesnt "change" it needs to be done manually
      {window.scrollTo(0,0)}
     
          return (
                <React.Fragment>


<Nav/>

                    <div className="mainWrapper">
                    <Fade appear mountOnEnter ssrFade left delay={100}>
                        <h1>{work.name}</h1>
                        
                        <p  className="work-paragraphs">{work.desc}</p>
                            <div>
                            <a target="blank" href={work.link}>{work.link.replace(/(^\w+:|^)\/\//, '')}</a>
                            </div>
    
                        <img className="workHero" src={work.mainImg} ></img>

                     <h2>Role</h2>
                     <p  className="work-paragraphs">{work.roleTags}</p>
                     <p  className="work-paragraphs">{work.role}</p>
                       
                        {Object.keys(work.imgs).map((key, e) => 
                            <img  src={work.imgs[e]} alt=""/>
                        )}
                        
                        </Fade>
                    </div>

                </React.Fragment>
            )
    } }

export default Work;